var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { computedFn } from 'mobx-utils';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class BrowserKeyboard {
    parent;
    latestInputAspect;
    latestInputAspectTime = 0;
    currentKeyDown = observable.map();
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.setupListeners();
        //  onBecomeObserved(this, 'currentKeyDown', this.setupListeners);
        // onBecomeUnobserved(this, 'currentKeyDown', this.clearListeners);
    }
    get browserRuntime() {
        return this.parent;
    }
    get app() {
        return this.browserRuntime.app;
    }
    get isKeyPressed() {
        return computedFn((key) => this.currentKeyDown.has(key));
    }
    onDocumentKeyDown(e) {
        if (e.defaultPrevented)
            return;
        this.currentKeyDown.set(e.key, e);
    }
    onDocumentKeyUp(e) {
        if (e.defaultPrevented)
            return;
        this.currentKeyDown.delete(e.key);
    }
    setupListeners() {
        window.addEventListener('keydown', this.onDocumentKeyDown);
        window.addEventListener('keyup', this.onDocumentKeyUp);
    }
    clearListeners() {
        window.removeEventListener('keydown', this.onDocumentKeyDown);
        window.removeEventListener('keyup', this.onDocumentKeyUp);
    }
}
__decorate([
    observable.shallow
], BrowserKeyboard.prototype, "currentKeyDown", void 0);
__decorate([
    memoize
], BrowserKeyboard.prototype, "isKeyPressed", null);
__decorate([
    action.bound
], BrowserKeyboard.prototype, "onDocumentKeyDown", null);
__decorate([
    action.bound
], BrowserKeyboard.prototype, "onDocumentKeyUp", null);
__decorate([
    action.bound
], BrowserKeyboard.prototype, "setupListeners", null);
__decorate([
    action.bound
], BrowserKeyboard.prototype, "clearListeners", null);
